module.exports = __webpack_public_path__ + "static/Menta-2d893d29a60cbf48b5b6a3b55e64721e.png";